import { createContext } from "react";
import AuthContextValue from "@/model/AuthContextValue";

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export default AuthContext;
